export function binarySearch<T>(
	sortedArray: T[],
	comparator: (element: T) => number,
): T | null {
	let startIndex = 0
	let endIndex = sortedArray.length - 1

	while (startIndex <= endIndex) {
		const middleIndex = Math.floor((startIndex + endIndex) / 2)
		const comparisonResult = comparator(sortedArray[middleIndex] as T)

		if (comparisonResult === 0) {
			return sortedArray[middleIndex] || null // Found the target
		} else if (comparisonResult < 0) {
			startIndex = middleIndex + 1 // Target is to the right
		} else {
			endIndex = middleIndex - 1 // Target is to the left
		}
	}

	// Target not found; find the closest index
	const closestIndex =
		endIndex < 0
			? startIndex
			: startIndex >= sortedArray.length
				? endIndex
				: Math.abs(comparator(sortedArray[startIndex] as T)) <
					  Math.abs(comparator(sortedArray[endIndex] as T))
					? startIndex
					: endIndex
	return closestIndex < sortedArray.length && closestIndex >= 0
		? sortedArray[closestIndex] || null
		: null
}
